var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseDatamigration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 428,
    viewBox: "0 0 274 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6232_99318)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6232_99318)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6232_99318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.099 569.309L194.098 569.309C194.094 569.308 194.091 569.307 194.087 569.307C194.085 569.306 194.082 569.306 194.079 569.305C194.064 569.302 194.049 569.299 194.035 569.296C194.052 569.3 194.069 569.304 194.087 569.307C194.091 569.307 194.094 569.308 194.098 569.309L194.099 569.309ZM139.266 491.591C139.267 491.579 139.269 491.568 139.27 491.556C139.273 491.542 139.275 491.529 139.278 491.515C139.272 491.54 139.269 491.566 139.266 491.591Z",
    fill: "url(#paint0_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.098 569.309L194.087 569.307L194.079 569.305C194.086 569.307 194.093 569.308 194.099 569.309L194.098 569.309ZM273.868 501.116V501.117C273.868 501.166 273.869 501.214 273.869 501.263C273.869 501.214 273.868 501.165 273.868 501.116ZM128.48 387.399C124.864 395.123 112.46 408.45 112.46 408.45L107.962 412.445C103.531 416.775 98.6567 419.365 96.6128 420.276C87.3168 424.924 76.8815 427.436 65.9178 427.145C29.9392 426.239 0.928389 396.216 0.0367662 358.965V357.12C0.0367662 356.914 0.0349201 356.71 0.0330798 356.507C0.0294163 356.103 0.0257756 355.701 0.0367662 355.291C0.911878 318.057 29.9227 288.034 65.9178 287.111C77.608 286.821 88.6872 289.692 98.429 294.938C104.902 298.235 112.678 297.108 117.797 291.81L140.946 267.854C147.254 261.326 148.707 251.466 144.959 243.093C141.194 234.703 138.981 225.408 138.734 215.616C138.536 208.047 139.543 200.716 141.541 193.813C142.597 190.104 143.918 186.516 145.52 183.081C149.136 175.358 147.666 166.13 141.805 160.064L117.913 135.338C112.745 129.99 104.852 128.879 98.33 132.314C89.6614 136.876 79.9196 139.576 69.5999 139.867C31.194 140.943 -0.78881 107.947 0.152348 68.2009C1.02746 30.9668 30.0382 0.943698 66.0334 0.0209626C104.439 -0.953036 136.34 32.1458 135.283 71.8918C135.002 82.5716 132.393 92.6534 127.985 101.624C124.666 108.374 125.739 116.525 130.907 121.89L154.056 145.847C160.364 152.375 169.891 153.879 177.982 150C186.089 146.104 195.071 143.814 204.532 143.558C242.938 142.481 274.921 175.477 273.98 215.223C273.369 241.265 258.971 263.77 238.067 275.27C237.968 275.324 237.866 275.38 237.764 275.436C237.544 275.558 237.318 275.683 237.093 275.799C236.68 276.021 236.267 276.244 235.855 276.449C226.36 281.302 215.677 283.933 204.417 283.608C194.592 283.335 185.28 280.874 176.925 276.705C169.462 272.963 160.545 274.484 154.684 280.55L130.792 305.276C125.624 310.624 124.55 318.792 127.869 325.542C129.223 328.276 130.379 331.129 131.37 334.068C131.376 334.097 131.386 334.126 131.397 334.153C131.402 334.167 131.407 334.18 131.412 334.193C131.421 334.216 131.429 334.237 131.436 334.256C131.766 335.23 132.08 336.221 132.36 337.212L132.608 338.084C132.839 338.904 133.054 339.707 133.235 340.527C133.351 341.04 133.467 341.57 133.582 342.082C133.623 342.278 133.666 342.475 133.708 342.671C133.803 343.108 133.899 343.548 133.978 343.996C134.127 344.765 134.243 345.534 134.358 346.303C134.379 346.438 134.401 346.572 134.424 346.708C134.473 347.001 134.522 347.298 134.556 347.602C134.705 348.661 134.804 349.738 134.903 350.831C134.903 350.945 134.918 351.059 134.932 351.173C134.94 351.23 134.947 351.287 134.953 351.344C135.101 353.241 135.167 355.172 135.167 357.12C135.167 360.281 134.986 363.391 134.589 366.432C134.567 366.637 134.531 366.842 134.494 367.047C134.476 367.15 134.457 367.253 134.441 367.355C134.409 367.565 134.378 367.775 134.347 367.985C134.25 368.646 134.153 369.304 134.028 369.953C133.925 370.518 133.807 371.075 133.69 371.63C133.637 371.88 133.584 372.13 133.533 372.379L133.503 372.524C133.447 372.804 133.388 373.093 133.318 373.37C132.179 378.274 130.561 382.973 128.48 387.399Z",
    fill: "url(#paint1_linear_6232_99318)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.5553 122.868C96.9889 122.868 120.025 99.5982 120.007 70.894C119.989 42.1898 96.925 18.9204 68.4914 18.9204C40.0578 18.9204 17.0221 42.1898 17.0398 70.894C17.0574 99.5982 40.1217 122.868 68.5553 122.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.477 215.209C259.319 186.816 236.72 163.124 207.999 162.292C179.278 161.459 155.313 183.801 154.471 212.194C153.628 240.587 176.228 264.279 204.949 265.112C233.669 265.944 257.635 243.602 258.477 215.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0078 407.924C95.4414 407.924 118.477 384.898 118.46 356.493C118.442 328.089 95.3781 305.062 66.9445 305.062C38.5109 305.062 15.4751 328.089 15.4926 356.493C15.51 384.898 38.5742 407.924 67.0078 407.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4935 360.047C92.0366 360.138 92.5498 359.772 92.6409 359.23C92.8853 357.777 93.009 356.288 93.009 354.806C93.009 340.168 81.0999 328.259 66.4616 328.259C51.8232 328.259 39.9141 340.168 39.9141 354.806C39.9141 369.444 51.8232 381.354 66.4616 381.354C68.4636 381.354 70.4625 381.128 72.4028 380.684C72.9391 380.562 73.2743 380.027 73.1516 379.491C73.0289 378.955 72.4942 378.62 71.9584 378.742C70.1636 379.153 68.3143 379.361 66.4614 379.361C52.9216 379.361 41.9061 368.346 41.9061 354.806C41.9061 341.266 52.9216 330.251 66.4614 330.251C80.0013 330.251 91.0167 341.266 91.0167 354.806C91.0167 356.178 90.9021 357.555 90.6762 358.899C90.5851 359.442 90.951 359.956 91.4935 360.047Z",
    fill: "url(#paint2_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6289 355.802H87.7582C88.3083 355.802 88.7542 355.356 88.7542 354.806C88.7542 354.256 88.3083 353.81 87.7582 353.81H85.6289C85.0788 353.81 84.6328 354.256 84.6328 354.806C84.6328 355.356 85.0788 355.802 85.6289 355.802Z",
    fill: "url(#paint3_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3013 354.806C48.3013 354.256 47.8553 353.81 47.3052 353.81H45.1758C44.6257 353.81 44.1797 354.256 44.1797 354.806C44.1797 355.356 44.6257 355.802 45.1758 355.802H47.305C47.8553 355.802 48.3013 355.356 48.3013 354.806Z",
    fill: "url(#paint4_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4648 372.974C65.9147 372.974 65.4688 373.419 65.4688 373.97V376.099C65.4688 376.649 65.9147 377.095 66.4648 377.095C67.015 377.095 67.4609 376.649 67.4609 376.099V373.97C67.4609 373.42 67.015 372.974 66.4648 372.974Z",
    fill: "url(#paint5_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4609 335.642V333.513C67.4609 332.963 67.015 332.517 66.4648 332.517C65.9147 332.517 65.4688 332.963 65.4688 333.513V335.642C65.4688 336.193 65.9147 336.639 66.4648 336.639C67.015 336.639 67.4609 336.193 67.4609 335.642Z",
    fill: "url(#paint6_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0422 339.206C76.3864 339.206 76.7212 339.028 76.9057 338.708L77.9704 336.864C78.2454 336.388 78.0822 335.778 77.6058 335.503C77.1292 335.228 76.5202 335.391 76.2451 335.868L75.1805 337.712C74.9054 338.188 75.0687 338.797 75.5451 339.073C75.7019 339.163 75.8732 339.206 76.0422 339.206Z",
    fill: "url(#paint7_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3792 370.54C56.9028 370.264 56.2936 370.428 56.0186 370.904L54.9539 372.748C54.6789 373.225 54.8421 373.834 55.3185 374.109C55.4753 374.199 55.6467 374.242 55.8156 374.242C56.1599 374.242 56.4947 374.064 56.6792 373.744L57.7438 371.9C58.0188 371.424 57.8556 370.815 57.3792 370.54Z",
    fill: "url(#paint8_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3695 344.362L48.5255 343.297C48.049 343.022 47.4399 343.185 47.1649 343.662C46.8898 344.138 47.053 344.747 47.5294 345.022L49.3734 346.087C49.5303 346.178 49.7016 346.221 49.8705 346.221C50.2148 346.221 50.5496 346.042 50.7341 345.722C51.0091 345.246 50.8459 344.637 50.3695 344.362Z",
    fill: "url(#paint9_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7438 337.712L56.6792 335.868C56.4041 335.391 55.7949 335.228 55.3185 335.503C54.8421 335.778 54.6789 336.388 54.9539 336.864L56.0186 338.708C56.203 339.027 56.5378 339.206 56.8821 339.206C57.051 339.206 57.2224 339.163 57.3792 339.072C57.8556 338.798 58.0188 338.188 57.7438 337.712Z",
    fill: "url(#paint10_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0284 366.449C48.1973 366.449 48.3687 366.406 48.5255 366.315L50.3695 365.25C50.8459 364.975 51.0091 364.366 50.7341 363.89C50.459 363.413 49.8498 363.25 49.3734 363.525L47.5294 364.59C47.053 364.865 46.8898 365.474 47.1649 365.951C47.3493 366.27 47.6842 366.449 48.0284 366.449Z",
    fill: "url(#paint11_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5646 346.087L85.4086 345.022C85.885 344.747 86.0482 344.138 85.7731 343.662C85.4981 343.185 84.8889 343.022 84.4125 343.297L82.5685 344.362C82.0921 344.637 81.9289 345.246 82.2039 345.723C82.3884 346.042 82.7232 346.221 83.0675 346.221C83.2364 346.221 83.4077 346.178 83.5646 346.087Z",
    fill: "url(#paint12_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4574 357.768C68.3806 357.456 69.1117 356.725 69.423 355.802H81.3663C81.9164 355.802 82.3624 355.356 82.3624 354.806C82.3624 354.256 81.9164 353.81 81.3663 353.81H69.423C69.0061 352.574 67.8364 351.681 66.4613 351.681C64.7379 351.681 63.3359 353.083 63.3359 354.806C63.3359 356.181 64.229 357.351 65.4652 357.768V369.711C65.4652 370.261 65.9112 370.707 66.4613 370.707C67.0114 370.707 67.4574 370.261 67.4574 369.711V357.768ZM66.4613 353.673C67.0862 353.673 67.5946 354.181 67.5946 354.806C67.5946 355.431 67.0862 355.939 66.4613 355.939C65.8364 355.939 65.3281 355.431 65.3281 354.806C65.3281 354.181 65.8364 353.673 66.4613 353.673Z",
    fill: "url(#paint13_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2379 377.806C98.0741 377.456 97.7224 377.232 97.3359 377.232H93.0087V363.323C93.0087 362.773 92.5627 362.327 92.0126 362.327H81.3662C80.8161 362.327 80.3701 362.773 80.3701 363.323V377.232H76.043C75.6565 377.232 75.3048 377.456 75.1409 377.806C74.977 378.156 75.0303 378.569 75.2777 378.866L85.9241 391.642C86.1134 391.869 86.3937 392 86.6894 392C86.985 392 87.2654 391.869 87.4546 391.642L98.101 378.866C98.3486 378.569 98.402 378.156 98.2379 377.806ZM86.6895 389.448L78.1698 379.224H81.3664C81.9165 379.224 82.3625 378.778 82.3625 378.228V364.319H91.0167V378.228C91.0167 378.778 91.4626 379.224 92.0128 379.224H95.2093L86.6895 389.448Z",
    fill: "url(#paint14_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3837 382.52C71.8224 383.25 69.1599 383.62 66.4702 383.62C58.7737 383.62 51.5379 380.623 46.0957 375.18C40.6534 369.738 37.6562 362.502 37.6562 354.806C37.6562 347.11 40.6534 339.874 46.0957 334.432C51.5378 328.989 58.7737 325.992 66.4702 325.992C74.1667 325.992 81.4024 328.989 86.8447 334.432C92.2869 339.874 95.284 347.11 95.284 354.806C95.284 356.888 95.0609 358.966 94.6209 360.982C94.5036 361.519 94.8441 362.05 95.3816 362.167C95.9187 362.284 96.4498 361.944 96.5672 361.407C97.0376 359.252 97.276 357.031 97.276 354.806C97.276 346.577 94.0717 338.841 88.2532 333.023C82.4346 327.204 74.6987 324 66.4702 324C58.2417 324 50.5055 327.204 44.6869 333.023C38.8684 338.841 35.6641 346.577 35.6641 354.806C35.6641 363.035 38.8684 370.771 44.6869 376.589C50.5055 382.408 58.2415 385.612 66.4701 385.612C69.3444 385.612 72.1906 385.217 74.9295 384.436C75.4585 384.285 75.7652 383.734 75.6145 383.205C75.4638 382.676 74.9127 382.369 74.3837 382.52Z",
    fill: "url(#paint15_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9825 81.2226C59.9306 81.2227 59.8788 81.2188 59.8275 81.2108C59.665 81.1855 59.5114 81.1201 59.3805 81.0207C59.2495 80.9212 59.1453 80.7908 59.0773 80.641L55.2215 72.147C55.1216 71.9269 55.1055 71.6778 55.1763 71.4466C55.2471 71.2154 55.3998 71.018 55.6059 70.8915L58.1473 69.3378C58.3456 69.2112 58.5826 69.1591 58.8157 69.1911C59.0489 69.223 59.2631 69.3367 59.4202 69.512L64.5953 75.3332C64.7583 75.5165 64.8476 75.7537 64.846 75.9989C64.8444 76.2442 64.752 76.4801 64.5866 76.6613L60.7172 80.8996C60.624 81.0016 60.5105 81.0831 60.384 81.1387C60.2575 81.1943 60.1207 81.2229 59.9825 81.2226ZM57.3921 72.1266L60.264 78.4506L62.5164 75.983L58.4864 71.4533L57.3921 72.1266Z",
    fill: "url(#paint16_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.721 81.2224C67.5831 81.2225 67.4467 81.1938 67.3206 81.1381C67.1944 81.0825 67.0812 81.0012 66.9882 80.8994L63.1188 76.6611C62.9534 76.4799 62.861 76.244 62.8594 75.9987C62.8578 75.7535 62.9471 75.5163 63.1101 75.333L68.2827 69.5119C68.4338 69.3421 68.6386 69.2293 68.8628 69.1924C69.0871 69.1555 69.3172 69.1967 69.5147 69.3091C69.532 69.3184 69.5488 69.329 69.5649 69.3395L72.0945 70.8895C72.3007 71.0159 72.4536 71.2132 72.5245 71.4444C72.5954 71.6756 72.5794 71.9248 72.4795 72.145L71.751 73.7502C71.698 73.87 71.6218 73.9782 71.5267 74.0684C71.4316 74.1587 71.3196 74.2291 71.1972 74.2758C71.0747 74.3225 70.9442 74.3445 70.8132 74.3404C70.6822 74.3364 70.5533 74.3064 70.434 74.2523C70.3146 74.1981 70.2072 74.1209 70.1178 74.025C70.0285 73.9291 69.9591 73.8164 69.9136 73.6935C69.868 73.5706 69.8473 73.4399 69.8526 73.3089C69.8579 73.178 69.8891 73.0494 69.9443 72.9305L70.3108 72.1245L69.2134 71.4518L65.1865 75.9815L67.4395 78.4492L67.6311 78.0275C67.6833 77.9063 67.7591 77.7968 67.8541 77.7052C67.9491 77.6137 68.0614 77.542 68.1845 77.4944C68.3075 77.4468 68.4389 77.4242 68.5707 77.428C68.7026 77.4318 68.8324 77.4618 68.9526 77.5164C69.0727 77.571 69.1807 77.6489 69.2704 77.7458C69.36 77.8426 69.4294 77.9563 69.4745 78.0803C69.5197 78.2043 69.5396 78.336 69.5332 78.4678C69.5268 78.5996 69.4941 78.7288 69.4372 78.8478L68.625 80.6409C68.5571 80.7903 68.4532 80.9206 68.3226 81.0201C68.192 81.1195 68.0388 81.185 67.8766 81.2106C67.8252 81.2186 67.7731 81.2225 67.721 81.2224Z",
    fill: "url(#paint17_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2271 63.405H57.2098C56.522 63.3863 55.8459 63.2225 55.2258 62.9245C54.0131 62.32 53.3317 61.2084 53.3125 59.7966C53.3064 59.6511 53.2904 59.5061 53.2647 59.3626C53.1407 58.6341 53.3211 57.9366 53.7737 57.4028C54.4061 56.6539 55.5209 56.2744 57.0883 56.2744H57.1205C57.2508 56.2746 57.3797 56.3005 57.5 56.3505C57.6203 56.4006 57.7295 56.4738 57.8215 56.5661C57.9135 56.6583 57.9864 56.7678 58.036 56.8882C58.0857 57.0087 58.1112 57.1377 58.111 57.268C58.1107 57.3982 58.0849 57.5272 58.0348 57.6475C57.9848 57.7677 57.9116 57.877 57.8193 57.969C57.727 58.0609 57.6176 58.1338 57.4971 58.1835C57.3767 58.2332 57.2477 58.2586 57.1174 58.2584H57.0864C55.7522 58.2584 55.374 58.5827 55.2884 58.6831C55.2617 58.7141 55.1811 58.8071 55.2202 59.0328V59.0477C55.2626 59.2853 55.2881 59.5256 55.2965 59.7669C55.307 60.4452 55.5593 60.8711 56.1149 61.1482C56.4702 61.314 56.8552 61.4068 57.247 61.421C57.5101 61.4233 57.7615 61.5301 57.9459 61.7177C58.1303 61.9054 58.2326 62.1586 58.2303 62.4217C58.228 62.6848 58.1213 62.9362 57.9336 63.1206C57.7459 63.305 57.4927 63.4073 57.2296 63.405H57.2271Z",
    fill: "url(#paint18_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4773 63.4051C70.347 63.4063 70.2178 63.3817 70.097 63.3329C69.9762 63.2841 69.8662 63.212 69.7733 63.1207C69.5856 62.9363 69.4789 62.6849 69.4766 62.4218C69.4743 62.1587 69.5766 61.9055 69.761 61.7178C69.9454 61.5302 70.1968 61.4234 70.4599 61.4211C70.8517 61.4069 71.2367 61.3141 71.592 61.1483C72.15 60.8712 72.398 60.4452 72.4104 59.7663C72.4176 59.526 72.4419 59.2865 72.483 59.0496C72.4833 59.0449 72.4833 59.0401 72.483 59.0354C72.5214 58.8109 72.4414 58.7161 72.4148 58.6844C72.3298 58.584 71.9492 58.2548 70.5957 58.2604H70.5926C70.3295 58.2604 70.0772 58.1559 69.8911 57.9698C69.7051 57.7838 69.6006 57.5315 69.6006 57.2684C69.6006 57.0053 69.7051 56.753 69.8911 56.5669C70.0772 56.3809 70.3295 56.2764 70.5926 56.2764H70.6193C72.186 56.2764 73.3001 56.6558 73.9325 57.4041C74.3845 57.9392 74.5656 58.6348 74.4422 59.3646C74.4164 59.508 74.4005 59.653 74.3944 59.7986C74.3727 61.2109 73.6914 62.322 72.4762 62.9265C71.856 63.2245 71.1799 63.3882 70.4922 63.407L70.4773 63.4051Z",
    fill: "url(#paint19_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1192 58.2603C56.8846 58.2601 56.6578 58.1764 56.4794 58.0241C54.3205 56.1908 53.3794 54.3097 53.6795 52.4336C54.0744 49.9684 56.5767 47.7836 61.1195 45.9329C63.9194 44.7927 67.0863 44.9991 69.8094 46.5002C72.148 47.6577 73.5052 49.2195 73.8481 51.1458C74.4631 54.6054 71.4493 57.817 71.3203 57.9522C71.1385 58.1408 70.8894 58.2498 70.6275 58.2554C70.3656 58.261 70.1121 58.1628 69.9223 57.9822C69.7326 57.8016 69.6219 57.5533 69.6146 57.2914C69.6073 57.0296 69.7038 56.7754 69.8832 56.5845C69.9303 56.5342 72.3346 53.9426 71.8932 51.4868C71.6644 50.214 70.6625 49.1308 68.9172 48.2715L68.8682 48.2455C66.6672 47.0278 64.1159 46.8554 61.8659 47.7705C58.1199 49.2957 55.9084 51.0627 55.638 52.7473C55.4551 53.8918 56.17 55.1585 57.7634 56.5119C57.9183 56.6434 58.0291 56.8192 58.0809 57.0157C58.1326 57.2121 58.1228 57.4197 58.0527 57.6104C57.9827 57.8011 57.8558 57.9657 57.6891 58.0819C57.5225 58.1982 57.3242 58.2604 57.1211 58.2603H57.1192Z",
    fill: "url(#paint20_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6795 71.1686C58.4164 71.1686 58.1641 71.064 57.978 70.878C57.792 70.692 57.6875 70.4396 57.6875 70.1766V66.2086C57.6875 65.9455 57.792 65.6931 57.978 65.5071C58.1641 65.3211 58.4164 65.2166 58.6795 65.2166C58.9426 65.2166 59.1949 65.3211 59.3809 65.5071C59.567 65.6931 59.6715 65.9455 59.6715 66.2086V70.1766C59.6715 70.4396 59.567 70.692 59.3809 70.878C59.1949 71.064 58.9426 71.1686 58.6795 71.1686Z",
    fill: "url(#paint21_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0311 71.1685C68.768 71.1685 68.5156 71.064 68.3296 70.878C68.1436 70.6919 68.0391 70.4396 68.0391 70.1765V66.1961C68.0391 65.933 68.1436 65.6807 68.3296 65.4947C68.5156 65.3086 68.768 65.2041 69.0311 65.2041C69.2942 65.2041 69.5465 65.3086 69.7325 65.4947C69.9185 65.6807 70.0231 65.933 70.0231 66.1961V70.1765C70.0231 70.4396 69.9185 70.6919 69.7325 70.878C69.5465 71.064 69.2942 71.1685 69.0311 71.1685Z",
    fill: "url(#paint22_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8514 90.9107C63.5883 90.9107 63.336 90.8062 63.1499 90.6201C62.9639 90.4341 62.8594 90.1818 62.8594 89.9187V75.9922C62.8594 75.7291 62.9639 75.4768 63.1499 75.2908C63.336 75.1048 63.5883 75.0002 63.8514 75.0002C64.1145 75.0002 64.3668 75.1048 64.5528 75.2908C64.7389 75.4768 64.8434 75.7291 64.8434 75.9922V89.9187C64.8434 90.1818 64.7389 90.4341 64.5528 90.6201C64.3668 90.8062 64.1145 90.9107 63.8514 90.9107Z",
    fill: "url(#paint23_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5328 90.9111H44.1954C44.056 90.9111 43.9182 90.8818 43.791 90.825C43.6637 90.7683 43.5499 90.6853 43.4568 90.5816C43.3637 90.4779 43.2936 90.3558 43.2509 90.2231C43.2082 90.0905 43.1939 89.9503 43.2089 89.8118L44.6969 76.1098C44.7162 75.5481 45.0776 74.5952 46.3567 74.1258L46.3691 74.1215L55.7987 70.8045C56.0422 70.7343 56.3033 70.7599 56.5285 70.8761C56.7537 70.9923 56.9259 71.1903 57.0097 71.4294C57.0936 71.6686 57.0827 71.9307 56.9794 72.1621C56.876 72.3935 56.688 72.5766 56.454 72.6738L47.03 75.9877C46.7901 76.077 46.6977 76.1737 46.6747 76.2171C46.6742 76.2355 46.6728 76.2539 46.6704 76.2723L45.2996 88.9265H68.5328C68.7959 88.9265 69.0483 89.031 69.2343 89.217C69.4203 89.403 69.5248 89.6554 69.5248 89.9185C69.5248 90.1816 69.4203 90.4339 69.2343 90.6199C69.0483 90.8059 68.7959 90.9105 68.5328 90.9105V90.9111Z",
    fill: "url(#paint24_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2264 90.9114C50.9633 90.9114 50.711 90.8069 50.5249 90.6209C50.3389 90.4348 50.2344 90.1825 50.2344 89.9194V82.9041C50.2344 82.641 50.3389 82.3887 50.5249 82.2027C50.711 82.0166 50.9633 81.9121 51.2264 81.9121C51.4895 81.9121 51.7418 82.0166 51.9278 82.2027C52.1139 82.3887 52.2184 82.641 52.2184 82.9041V89.9194C52.2184 90.1825 52.1139 90.4348 51.9278 90.6209C51.7418 90.8069 51.4895 90.9114 51.2264 90.9114Z",
    fill: "url(#paint25_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8545 70.176C61.7509 70.176 59.7855 69.184 58.321 67.386C56.905 65.6444 56.125 63.3424 56.125 60.9033V54.4962C56.1244 54.1057 56.2101 53.7198 56.3757 53.3662C56.5414 53.0125 56.7831 52.6998 57.0835 52.4502L58.0203 51.6696C58.7124 51.0934 59.5846 50.7778 60.4852 50.7778C61.3857 50.7778 62.2579 51.0934 62.95 51.6696C63.4097 52.0527 63.9041 52.392 64.4268 52.6833C64.9501 52.9742 65.4993 53.2158 66.0673 53.405L66.3686 53.5048C66.9257 53.689 67.5272 53.689 68.0842 53.5048C68.4843 53.3705 68.9106 53.3334 69.3279 53.3967C69.7452 53.4599 70.1414 53.6216 70.4838 53.8684C70.8262 54.1152 71.1048 54.44 71.2967 54.8159C71.4886 55.1918 71.5882 55.6081 71.5872 56.0301V60.9002C71.5872 63.3393 70.8066 65.6413 69.3893 67.3829C67.9236 69.184 65.9576 70.176 63.8545 70.176ZM60.4848 52.7621C60.0478 52.7622 59.6248 52.9158 59.2895 53.1961L58.3527 53.9767C58.2761 54.0402 58.2146 54.1197 58.1723 54.2098C58.1301 54.2998 58.1083 54.398 58.1084 54.4975V60.899C58.1084 64.9209 60.6857 68.192 63.8539 68.192C67.006 68.192 69.574 64.9575 69.6019 60.9678C69.6019 60.9448 69.6019 60.9225 69.6019 60.899C69.6019 60.8754 69.6019 60.8512 69.6019 60.8277V56.0307C69.602 55.8509 69.5309 55.6784 69.4044 55.5507C69.2778 55.4229 69.1059 55.3504 68.9261 55.3487C68.8523 55.3492 68.779 55.3615 68.7091 55.3853C67.7455 55.704 66.7049 55.704 65.7412 55.3853L65.4399 55.2849C64.0665 54.8278 62.7909 54.1177 61.679 53.1911C61.3432 52.9131 60.9208 52.7613 60.4848 52.7621Z",
    fill: "url(#paint26_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7467 82.6932H70.5948C69.7867 82.6924 69.0119 82.371 68.4405 81.7996C67.8691 81.2282 67.5477 80.4534 67.5469 79.6453V75.402C67.5479 74.594 67.8693 73.8194 68.4407 73.2481C69.0121 72.6769 69.7868 72.3556 70.5948 72.3547H91.7467C92.5546 72.3557 93.3291 72.6771 93.9004 73.2484C94.4717 73.8196 94.793 74.5941 94.794 75.402V79.6478C94.7925 80.4554 94.471 81.2294 93.8997 81.8003C93.3285 82.3711 92.5543 82.6923 91.7467 82.6932ZM70.5948 74.3363C70.4549 74.3363 70.3165 74.364 70.1873 74.4176C70.0582 74.4712 69.9408 74.5497 69.842 74.6487C69.7432 74.7477 69.6649 74.8652 69.6115 74.9944C69.5581 75.1237 69.5307 75.2622 69.5309 75.402V79.6478C69.5312 79.9299 69.6434 80.2003 69.8429 80.3997C70.0423 80.5992 70.3127 80.7114 70.5948 80.7117H91.7467C92.0291 80.7112 92.2997 80.5986 92.4991 80.3986C92.6985 80.1987 92.8103 79.9277 92.81 79.6453V75.402C92.8097 75.1201 92.6976 74.8499 92.4982 74.6505C92.2989 74.4512 92.0286 74.3391 91.7467 74.3387L70.5948 74.3363Z",
    fill: "url(#paint27_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7467 94.0063H70.5948C69.7868 94.0054 69.0121 93.6841 68.4407 93.1129C67.8693 92.5416 67.5479 91.767 67.5469 90.959V86.7126C67.5479 85.9046 67.8693 85.13 68.4407 84.5587C69.0121 83.9874 69.7868 83.6661 70.5948 83.6653H91.7467C92.5546 83.6663 93.3291 83.9876 93.9004 84.5589C94.4717 85.1302 94.793 85.9047 94.794 86.7126V90.959C94.793 91.7669 94.4717 92.5414 93.9004 93.1126C93.3291 93.6839 92.5546 94.0053 91.7467 94.0063ZM70.5948 85.6493C70.3128 85.6494 70.0424 85.7615 69.8429 85.9609C69.6434 86.1602 69.5312 86.4306 69.5309 86.7126V90.959C69.5314 91.2409 69.6436 91.5112 69.8431 91.7105C70.0425 91.9098 70.3128 92.0219 70.5948 92.0223H91.7467C92.0286 92.0218 92.2987 91.9096 92.498 91.7103C92.6973 91.511 92.8095 91.2408 92.81 90.959V86.7126C92.8097 86.4307 92.6976 86.1604 92.4982 85.9611C92.2989 85.7617 92.0286 85.6496 91.7467 85.6493H70.5948Z",
    fill: "url(#paint28_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5389 85.6487C72.2758 85.6487 72.0235 85.5441 71.8374 85.3581C71.6514 85.1721 71.5469 84.9198 71.5469 84.6567V81.7005C71.5469 81.4374 71.6514 81.1851 71.8374 80.999C72.0235 80.813 72.2758 80.7085 72.5389 80.7085C72.802 80.7085 73.0543 80.813 73.2403 80.999C73.4264 81.1851 73.5309 81.4374 73.5309 81.7005V84.6567C73.5309 84.9198 73.4264 85.1721 73.2403 85.3581C73.0543 85.5441 72.802 85.6487 72.5389 85.6487Z",
    fill: "url(#paint29_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8045 85.6487C89.5414 85.6487 89.2891 85.5441 89.103 85.3581C88.917 85.1721 88.8125 84.9198 88.8125 84.6567V81.7005C88.8125 81.4374 88.917 81.1851 89.103 80.999C89.2891 80.813 89.5414 80.7085 89.8045 80.7085C90.0676 80.7085 90.3199 80.813 90.506 80.999C90.692 81.1851 90.7965 81.4374 90.7965 81.7005V84.6567C90.7965 84.9198 90.692 85.1721 90.506 85.3581C90.3199 85.5441 90.0676 85.6487 89.8045 85.6487Z",
    fill: "url(#paint30_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9492 96.7921H85.944C85.2236 96.7913 84.5328 96.5047 84.0234 95.9953C83.514 95.4858 83.2274 94.7951 83.2266 94.0747V93.0145C83.2266 92.7514 83.3311 92.499 83.5171 92.313C83.7032 92.127 83.9555 92.0225 84.2186 92.0225H90.6746C90.9377 92.0225 91.19 92.127 91.3761 92.313C91.5621 92.499 91.6666 92.7514 91.6666 93.0145V94.0747C91.6658 94.7951 91.3792 95.4858 90.8698 95.9953C90.3603 96.5047 89.6696 96.7913 88.9492 96.7921ZM85.2106 94.0065V94.0747C85.2109 94.2691 85.2883 94.4555 85.4258 94.5929C85.5632 94.7304 85.7496 94.8078 85.944 94.8081H88.9492C89.1436 94.8078 89.33 94.7304 89.4674 94.5929C89.6049 94.4555 89.6823 94.2691 89.6826 94.0747V94.0065H85.2106Z",
    fill: "url(#paint31_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3945 96.7921H73.3893C72.6689 96.7913 71.9782 96.5047 71.4687 95.9953C70.9593 95.4858 70.6727 94.7951 70.6719 94.0747V93.0145C70.6719 92.7514 70.7764 92.499 70.9624 92.313C71.1485 92.127 71.4008 92.0225 71.6639 92.0225H78.1199C78.383 92.0225 78.6354 92.127 78.8214 92.313C79.0074 92.499 79.1119 92.7514 79.1119 93.0145V94.0747C79.1111 94.7951 78.8245 95.4858 78.3151 95.9953C77.8057 96.5047 77.1149 96.7913 76.3945 96.7921ZM72.6559 94.0065V94.0747C72.6562 94.2691 72.7336 94.4555 72.8711 94.5929C73.0085 94.7304 73.1949 94.8078 73.3893 94.8081H76.3945C76.5889 94.8078 76.7753 94.7304 76.9127 94.5929C77.0502 94.4555 77.1276 94.2691 77.1279 94.0747V94.0065H72.6559Z",
    fill: "url(#paint32_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.157 78.5143H82.367C82.1039 78.5143 81.8516 78.4098 81.6655 78.2237C81.4795 78.0377 81.375 77.7854 81.375 77.5223C81.375 77.2592 81.4795 77.0069 81.6655 76.8208C81.8516 76.6348 82.1039 76.5303 82.367 76.5303H85.157C85.4201 76.5303 85.6724 76.6348 85.8585 76.8208C86.0445 77.0069 86.149 77.2592 86.149 77.5223C86.149 77.7854 86.0445 78.0377 85.8585 78.2237C85.6724 78.4098 85.4201 78.5143 85.157 78.5143Z",
    fill: "url(#paint33_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9148 78.5143H88.1248C87.8617 78.5143 87.6094 78.4098 87.4234 78.2237C87.2373 78.0377 87.1328 77.7854 87.1328 77.5223C87.1328 77.2592 87.2373 77.0069 87.4234 76.8208C87.6094 76.6348 87.8617 76.5303 88.1248 76.5303H90.9148C91.1779 76.5303 91.4302 76.6348 91.6163 76.8208C91.8023 77.0069 91.9068 77.2592 91.9068 77.5223C91.9068 77.7854 91.8023 78.0377 91.6163 78.2237C91.4302 78.4098 91.1779 78.5143 90.9148 78.5143Z",
    fill: "url(#paint34_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9148 89.8275H88.1248C87.8617 89.8275 87.6094 89.723 87.4234 89.537C87.2373 89.3509 87.1328 89.0986 87.1328 88.8355C87.1328 88.5724 87.2373 88.3201 87.4234 88.1341C87.6094 87.948 87.8617 87.8435 88.1248 87.8435H90.9148C91.1779 87.8435 91.4302 87.948 91.6163 88.1341C91.8023 88.3201 91.9068 88.5724 91.9068 88.8355C91.9068 89.0986 91.8023 89.3509 91.6163 89.537C91.4302 89.723 91.1779 89.8275 90.9148 89.8275Z",
    fill: "url(#paint35_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.157 89.8275H82.367C82.1039 89.8275 81.8516 89.723 81.6655 89.537C81.4795 89.3509 81.375 89.0986 81.375 88.8355C81.375 88.5724 81.4795 88.3201 81.6655 88.1341C81.8516 87.948 82.1039 87.8435 82.367 87.8435H85.157C85.4201 87.8435 85.6724 87.948 85.8585 88.1341C86.0445 88.3201 86.149 88.5724 86.149 88.8355C86.149 89.0986 86.0445 89.3509 85.8585 89.537C85.6724 89.723 85.4201 89.8275 85.157 89.8275Z",
    fill: "url(#paint36_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6232_99318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.219 223.327V204.785C235.216 202.596 234.651 200.446 233.583 198.555C232.515 196.665 230.981 195.1 229.137 194.021L213.137 184.667C211.325 183.63 209.288 183.086 207.217 183.086C205.146 183.086 203.109 183.63 201.298 184.667L185.298 194.022C183.455 195.101 181.921 196.666 180.853 198.557C179.786 200.447 179.222 202.596 179.219 204.785V223.327C179.222 225.516 179.786 227.666 180.855 229.556C181.923 231.447 183.457 233.012 185.301 234.091L201.301 243.444C203.106 244.5 205.145 245.055 207.219 245.055C209.294 245.055 211.333 244.5 213.138 243.444L229.138 234.091C230.981 233.011 232.514 231.446 233.582 229.556C234.65 227.665 235.215 225.516 235.219 223.327ZM228.154 232.292L212.154 241.646C210.644 242.51 208.946 242.963 207.22 242.963C205.494 242.963 203.797 242.51 202.287 241.646L186.287 232.292C184.751 231.393 183.473 230.09 182.582 228.516C181.692 226.941 181.222 225.15 181.219 223.327V204.785C181.221 202.962 181.691 201.171 182.581 199.597C183.471 198.022 184.749 196.719 186.285 195.82L202.285 186.464C203.79 185.584 205.49 185.122 207.219 185.122C208.949 185.122 210.649 185.584 212.154 186.464L228.154 195.819C229.689 196.718 230.967 198.021 231.857 199.596C232.747 201.171 233.216 202.962 233.219 204.785V223.327C233.216 225.15 232.746 226.94 231.856 228.515C230.967 230.09 229.689 231.393 228.154 232.292Z",
    fill: "url(#paint37_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.675 198.518L210.675 189.162C209.62 188.549 208.429 188.227 207.219 188.227C206.008 188.227 204.818 188.549 203.763 189.162L187.763 198.518C186.689 199.146 185.795 200.057 185.172 201.158C184.55 202.259 184.221 203.51 184.219 204.785V223.326C184.221 224.602 184.55 225.853 185.172 226.954C185.795 228.055 186.689 228.966 187.763 229.594L203.763 238.948C204.818 239.562 206.008 239.884 207.219 239.884C208.429 239.884 209.62 239.562 210.675 238.948L226.675 229.594C227.749 228.966 228.642 228.055 229.265 226.954C229.888 225.853 230.217 224.602 230.219 223.326V204.785C230.217 203.51 229.888 202.259 229.265 201.158C228.643 200.057 227.749 199.146 226.675 198.518ZM194.219 229.555H191.757L190.219 228.656V221.289H194.219V229.555ZM209.691 237.15C208.936 237.588 208.084 237.818 207.219 237.818C206.353 237.818 205.502 237.588 204.747 237.15L195.292 231.622H219.146L209.691 237.15ZM204.219 229.555H200.219V217.155H204.219V229.555ZM214.219 229.555H210.219V213.022H214.219V229.555ZM224.219 228.656L222.681 229.555H220.219V205.789H224.219V228.656ZM228.219 223.326C228.217 224.125 228.035 224.912 227.688 225.625C227.341 226.339 226.838 226.958 226.219 227.436V205.789C226.219 205.241 226.008 204.715 225.633 204.327C225.258 203.94 224.749 203.722 224.219 203.722H220.219C219.688 203.722 219.18 203.94 218.805 204.327C218.429 204.715 218.219 205.241 218.219 205.789V229.555H216.219V213.022C216.219 212.474 216.008 211.948 215.633 211.561C215.258 211.173 214.749 210.955 214.219 210.955H210.219C209.688 210.955 209.18 211.173 208.805 211.561C208.429 211.948 208.219 212.474 208.219 213.022V229.555H206.219V217.155C206.219 216.607 206.008 216.082 205.633 215.694C205.258 215.306 204.749 215.089 204.219 215.089H200.219C199.688 215.089 199.18 215.306 198.805 215.694C198.429 216.082 198.219 216.607 198.219 217.155V229.555H196.219V221.289C196.219 220.741 196.008 220.215 195.633 219.827C195.258 219.44 194.749 219.222 194.219 219.222H190.219C189.688 219.222 189.18 219.44 188.805 219.827C188.429 220.215 188.219 220.741 188.219 221.289V227.436C187.6 226.958 187.096 226.339 186.749 225.625C186.402 224.912 186.221 224.125 186.219 223.326V204.785C186.22 203.875 186.454 202.982 186.898 202.196C187.343 201.41 187.98 200.76 188.747 200.312L204.747 190.956C205.502 190.519 206.353 190.289 207.219 190.289C208.084 190.289 208.936 190.519 209.691 190.956L225.691 200.312C226.457 200.76 227.095 201.41 227.539 202.196C227.983 202.982 228.218 203.875 228.219 204.785V223.326Z",
    fill: "url(#paint38_linear_6232_99318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.751 199.844L210.951 198.562C210.702 198.487 210.434 198.515 210.205 198.64C209.975 198.765 209.802 198.978 209.721 199.233C209.641 199.488 209.659 199.765 209.773 200.006C209.886 200.247 210.086 200.433 210.33 200.525L211.838 201.034L188.768 213.134C188.645 213.191 188.535 213.274 188.443 213.376C188.352 213.479 188.282 213.6 188.237 213.731C188.192 213.863 188.173 214.002 188.182 214.141C188.19 214.28 188.226 214.416 188.287 214.541C188.348 214.665 188.432 214.776 188.535 214.866C188.639 214.955 188.758 215.023 188.887 215.063C189.016 215.104 189.152 215.118 189.286 215.103C189.42 215.088 189.55 215.045 189.668 214.977L212.737 202.877L212.245 204.434C212.171 204.692 212.197 204.97 212.318 205.208C212.439 205.446 212.645 205.626 212.893 205.71C213.14 205.794 213.409 205.774 213.643 205.656C213.877 205.538 214.057 205.33 214.145 205.077L215.386 201.15C215.427 201.021 215.444 200.885 215.434 200.75C215.425 200.614 215.389 200.482 215.33 200.361C215.271 200.24 215.19 200.132 215.09 200.043C214.991 199.954 214.876 199.887 214.751 199.844Z",
    fill: "url(#paint39_linear_6232_99318)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6232_99318",
    x: -9.36875,
    y: -9.4,
    width: 292.769,
    height: 588.109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6232_99318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6232_99318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6232_99318",
    x1: 34.25,
    y1: 139.23,
    x2: 343.807,
    y2: 235.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C84CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA64B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6232_99318",
    x1: 34.25,
    y1: 139.23,
    x2: 343.807,
    y2: 235.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C84CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA64B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6232_99318",
    x1: 46.5509,
    y1: 338.612,
    x2: 86.3722,
    y2: 370.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6232_99318",
    x1: 85.148,
    y1: 354.199,
    x2: 86.4961,
    y2: 356.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6232_99318",
    x1: 44.6949,
    y1: 354.199,
    x2: 46.0429,
    y2: 356.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6232_99318",
    x1: 65.7178,
    y1: 373.777,
    x2: 67.8587,
    y2: 374.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6232_99318",
    x1: 65.7178,
    y1: 333.321,
    x2: 67.8587,
    y2: 334.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6232_99318",
    x1: 75.429,
    y1: 336.118,
    x2: 78.1072,
    y2: 337.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6232_99318",
    x1: 55.2024,
    y1: 371.154,
    x2: 57.8807,
    y2: 372.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6232_99318",
    x1: 47.5108,
    y1: 343.759,
    x2: 49.8567,
    y2: 346.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6232_99318",
    x1: 55.2024,
    y1: 336.118,
    x2: 57.8806,
    y2: 337.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6232_99318",
    x1: 47.5108,
    y1: 363.988,
    x2: 49.8566,
    y2: 366.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6232_99318",
    x1: 82.5499,
    y1: 343.76,
    x2: 84.8957,
    y2: 346.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6232_99318",
    x1: 65.7142,
    y1: 355.391,
    x2: 79.9841,
    y2: 366.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6232_99318",
    x1: 77.9575,
    y1: 368.113,
    x2: 98.5384,
    y2: 381.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6232_99318",
    x1: 43.3656,
    y1: 336.014,
    x2: 89.5747,
    y2: 373.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6232_99318",
    x1: 56.347,
    y1: 71.5298,
    x2: 64.7949,
    y2: 77.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6232_99318",
    x1: 64.073,
    y1: 71.5276,
    x2: 72.5204,
    y2: 77.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6232_99318",
    x1: 53.852,
    y1: 57.6649,
    x2: 58.5436,
    y2: 60.3206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6232_99318",
    x1: 70.102,
    y1: 57.6668,
    x2: 74.7934,
    y2: 60.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6232_99318",
    x1: 56.1632,
    y1: 47.7507,
    x2: 65.9293,
    y2: 60.0036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6232_99318",
    x1: 57.9355,
    y1: 66.3772,
    x2: 60.2261,
    y2: 66.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6232_99318",
    x1: 68.2871,
    y1: 66.3672,
    x2: 70.5783,
    y2: 66.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6232_99318",
    x1: 63.1074,
    y1: 78.1028,
    x2: 65.539,
    y2: 78.3474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6232_99318",
    x1: 46.4933,
    y1: 74.694,
    x2: 61.9311,
    y2: 90.9651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6232_99318",
    x1: 50.4824,
    y1: 83.667,
    x2: 52.8633,
    y2: 84.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6232_99318",
    x1: 58.0578,
    y1: 54.5605,
    x2: 71.6012,
    y2: 63.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6232_99318",
    x1: 70.9528,
    y1: 74.3707,
    x2: 77.0641,
    y2: 87.3632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6232_99318",
    x1: 70.9528,
    y1: 85.6818,
    x2: 77.0665,
    y2: 98.6762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6232_99318",
    x1: 71.7949,
    y1: 81.6718,
    x2: 74.0178,
    y2: 82.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6232_99318",
    x1: 89.0605,
    y1: 81.6718,
    x2: 91.2835,
    y2: 82.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6232_99318",
    x1: 84.2816,
    y1: 92.9525,
    x2: 87.7216,
    y2: 97.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6232_99318",
    x1: 71.7269,
    y1: 92.9525,
    x2: 75.1669,
    y2: 97.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6232_99318",
    x1: 81.9717,
    y1: 76.9172,
    x2: 83.2114,
    y2: 79.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6232_99318",
    x1: 87.7296,
    y1: 76.9172,
    x2: 88.9692,
    y2: 79.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6232_99318",
    x1: 87.7296,
    y1: 88.2304,
    x2: 88.9692,
    y2: 90.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6232_99318",
    x1: 81.9717,
    y1: 88.2304,
    x2: 83.2114,
    y2: 90.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6232_99318",
    x1: 186.219,
    y1: 195.17,
    x2: 231.491,
    y2: 228.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6232_99318",
    x1: 189.969,
    y1: 198.3,
    x2: 227.534,
    y2: 225.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6232_99318",
    x1: 191.587,
    y1: 201.755,
    x2: 203.827,
    y2: 217.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6232_99318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 428,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6232_99318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6232_99318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 62,
    fill: "white",
    transform: "translate(177.219 183.055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseDatamigration);
export default __webpack_public_path__ + "static/media/why_choose_datamigration.dbca899dcc650dc7bee0abe8f335b182.svg";
export { ForwardRef as ReactComponent };